import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const RiskProfileContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RiskProfileProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["risk_profile"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=risk-profile`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <RiskProfileContext.Provider value={contextValue}>
      {children}
    </RiskProfileContext.Provider>
  );
};

export default RiskProfileProvider;
